import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { sendNotification } from 'utils/helperMethods';

export interface RunOptimizationResponse {
    job_id: string;
}

const runOptimizationRequest = async (payload: Record<string, unknown>): Promise<RunOptimizationResponse> => {
    const response = await axios(tpoGenUrls.runOptimisation, {
        method: 'POST',
        data: payload,
    });
    return response.data;
};

const useRunOptimizationMutation = () => {
    const { mutate, isPending } = useMutation({
        mutationFn: runOptimizationRequest,
        onError: (error: unknown) => {
            const detail = (error as { response?: { data?: { detail?: string } } })?.response?.data?.detail;
            sendNotification('error', detail ?? 'Something Went Wrong');
        },
    });

    return { mutate, isPending };
};

export default useRunOptimizationMutation;
